// PlayButton.js
var PlayButton = pc.createScript('playButton');

PlayButton.prototype.initialize = function () {

    PlayButton.instance = this;

    this.entity.button.once('click', function (event) {

        this.entity.button.active = false;
        playExtraTime = false;
        if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "PlayButton:Click", 1); }

        PlayerManager.instance.userData.gameMode = gamePlayMode.Normal;

        loadScene(`LoadingScene`, { hierarchy: true, settings: true }, () => {

            if (PlayerManager.instance.userData.newPlayer == true && isTutorialStageComplete == false) {
                PreloadManager.instance.loadMiniGameAssets("DonutItem", function (complete) {
                    if (complete) {

                        loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                            GameManager.instance.GameStart();
                        });
                    }
                });
            }
            else {
                PreloadManager.instance.loadGameAssets(PlayerManager.instance.levelData.levelItem, function(complete){
                    if (complete){
                        
                        loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                            
                            if (PlayerManager.instance.userData.interruption == 1 && (PlayerManager.instance.userData.placeMode === false)) {

                                this.app.root.findByName("RestorePanel").enabled = true;
                            }
                            else {
                                GameManager.instance.GameStart();
                            }
                        });
                    }
                });
            }

        });

    }, this);
    progressVal = 0.12;


};




